<template>
    <div>
        <div class="loading-overlay" v-show="loading"></div>
        <div class="loading-dialog" v-show="loading || isLoading">
            <div class="loading-dialog-body">
                <div class="loading_modal">
                    <i class="fa fa-heart heartbeat"></i>
                    <br />
                    <br />
                    <span class="title">LOADING</span>
                </div>
            </div>
        </div>
        <div class="loading-dialog" v-if="spinLoading">
            <div class="loading-dialog-body">
                <div class="spinLoading-modal">
                    <span class="bold"
                        ><strong
                            ><b>
                                {{ loaderText }}
                            </b></strong
                        ></span
                    >
                    <br />
                    <br />
                    <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./LoadingIndicator.scss"></style>

<script lang="ts">
import { defineComponent } from "vue";
import { useLoadingIndicator } from "./store/useLoadingIndicator";
import { mapState } from "pinia";

export default defineComponent({
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapState(useLoadingIndicator, ["loading", "spinLoading", "loaderText"])
    }
});
</script>
